<template>
  <div class="belts">
    <div class="container"> 
      <h1 class="headline">GCO {{$t('message.beltGrades')}}</h1>
      <div class="loading" v-if="belts == null"></div> 
      
      <div class="simple-list-outer" v-if="belts != null">                
        <div class="simple-list-item" v-for="(item, index) in belts" @click="goBelt(item.id, item.belt)" v-if="index < 8">  
          <div class="simple-list-item-image"><img :src="beltsPath + item.icon"/></div>
          <div class="simple-list-item-title">{{item.belt}}</div>
          <div class="simple-list-item-additional">{{item.memberCount}}</div>               
        </div> 
      </div>
        
      <div class="simple-list-divider"><hr></div>
        
      <div class="simple-list-outer" v-if="belts != null">  
        <div class="simple-list-item inactive" v-for="(item, index) in belts" v-if="index >= 8 && item.belt !== 'unknown'">  
          <div class="simple-list-item-image"><img :src="beltsPath + item.icon"/></div>
          <div class="simple-list-item-title">{{item.belt}}</div>
          <div class="simple-list-item-additional">{{item.memberCount}}</div>               
        </div>        
      </div>
      
      <div v-if="belts != null">
        <div v-for="(item, index) in belts" v-if="item.belt === 'unknown'">  
          {{item.memberCount}} {{$t('message.unknownBeltsFound')}}
        </div>        
      </div>
      
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'belts',
  data () {
    return {
      test: null
    }
  },
  methods: {
    initSearchField: function () {
      this.searchText = ''
    },
    getBelts: function () {
      this.$store.dispatch('members/getBelts')
    },
    goBelt: function (id, name) {
      // window.location.href = './#/belts/' + id + '/members'
      var breadcrumb = {
        name: name,
        route: '/belts/' + id + '/members'
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push({path: breadcrumb.route})
    }
  },
  computed: {
    ...mapGetters({
      belts: 'members/belts',
      flagsPath: 'countries/flagsPath',
      beltsPath: 'members/beltsPath'
    })
  },
  created: function () {
    this.getBelts()
  }
}
</script>
